module.exports = __webpack_public_path__ + "static/media/Sentient_CombatZone.81be4999.png";